import { PaymentMethodTypes, UNKNOWN_PAYMENT_METHOD } from '../../adyen/adyen';

export const PAYMENT_METHOD_TO_GTM: Record<PaymentMethodTypes, string | undefined> = {
  [PaymentMethodTypes.CREDIT_OR_DEBIT]: 'credit_debit',
  [PaymentMethodTypes.PAYPAL]: 'paypal',
  [PaymentMethodTypes.GOOGLE_PAY]: 'google_pay',
  [PaymentMethodTypes.APPLE_PAY]: 'apple_pay',
  [PaymentMethodTypes.GIFT_CARD]: 'gift_card',
  [PaymentMethodTypes.KLARNA]: 'klarna_pay_later',
  [PaymentMethodTypes.KLARNA_ACCOUNT]: 'klarna_over_time',
  [PaymentMethodTypes.KLARNA_PAYNOW]: 'klarna_pay_now',
  [PaymentMethodTypes.IDEAL]: 'ideal',
  [PaymentMethodTypes.MBWAY]: 'mb_way',
  [PaymentMethodTypes.MOBILE_PAY]: 'mobile_pay',
  [PaymentMethodTypes.ONLINE_BANKING_PL]: 'przelewy24',
  [PaymentMethodTypes.TWINT]: 'twint',
  [PaymentMethodTypes.MULTIBANCO]: 'multibanco',
  [PaymentMethodTypes.BANCONTACT_MOBILE]: 'bancontact_mobile',
  [PaymentMethodTypes.GROUP_KLARNA]: undefined,
};

/**
 * Gets the GTM-formatted payment method name from the payment method type
 */
export function convertPaymentMethodToGTM(method: PaymentMethodTypes): string {
  return PAYMENT_METHOD_TO_GTM[method] ?? UNKNOWN_PAYMENT_METHOD;
}
